<template><section><template>
<h3>Input</h3>
<div class="bs-docs-section">
<div class="bs-example">
<p><n3-input v-model="value" ref="input" show-clean=""></n3-input>
<n3-button @click.native="$refs.input.focus()">focus</n3-button></p>
</div>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-input</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"value"</span> <span class="hljs-attr">ref</span>=<span class="hljs-string">"input"</span> <span class="hljs-attr">icon</span>=<span class="hljs-string">"archive"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-input</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-button</span> <span class="hljs-attr">@click.native</span>=<span class="hljs-string">"$refs.input.focus()"</span>&gt;</span>focus<span class="hljs-tag">&lt;/<span class="hljs-name">n3-button</span>&gt;</span>
</code></pre>
<h3>Password Input</h3>
<p><n3-input v-model="value2" type="password" ref="input2" show-clean=""></n3-input>
<n3-button @click.native="$refs.input2.focus()">focus</n3-button></p>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-input</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"value2"</span> <span class="hljs-attr">ref</span>=<span class="hljs-string">"password"</span> <span class="hljs-attr">icon</span>=<span class="hljs-string">"archive"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-input</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-button</span> <span class="hljs-attr">@click.native</span>=<span class="hljs-string">"$refs.input2.focus()"</span>&gt;</span>focus<span class="hljs-tag">&lt;/<span class="hljs-name">n3-button</span>&gt;</span>
</code></pre>
<h3>Params</h3>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td>name</td>
<td><code v-pre="">String</code></td>
<td>－</td>
<td></td>
</tr>
<tr>
<td>readonly</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td>readonly</td>
</tr>
<tr>
<td>disabled</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td>disabled</td>
</tr>
<tr>
<td>width</td>
<td><code v-pre="">String</code></td>
<td><code v-pre="">220px</code></td>
<td>width</td>
</tr>
<tr>
<td>placeholder</td>
<td><code v-pre="">String</code></td>
<td>－</td>
<td>placeholder</td>
</tr>
<tr>
<td>type</td>
<td><code v-pre="">String</code></td>
<td><code v-pre="">text</code></td>
<td>type <code v-pre="">number</code> <code v-pre="">password</code> <code v-pre="">test</code></td>
</tr>
<tr>
<td>icon</td>
<td><code v-pre="">String</code></td>
<td>-</td>
<td>icon</td>
</tr>
<tr>
<td>show-clean</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td>clean icon</td>
</tr>
</tbody>
</table>
<h3>Methods</h3>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td>clean</td>
<td>clean value</td>
</tr>
<tr>
<td>focus</td>
<td>focus</td>
</tr>
<tr>
<td>blur</td>
<td>blur</td>
</tr>
</tbody>
</table>
<h3>Events</h3>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>params</th>
</tr>
</thead>
<tbody>
<tr>
<td>blur</td>
<td>blur</td>
<td>-</td>
</tr>
<tr>
<td>focus</td>
<td>focus</td>
<td>-</td>
</tr>
<tr>
<td>change</td>
<td>change</td>
<td>(currentValue)</td>
</tr>
</tbody>
</table>
<p>PS: params of form components，look <a href="#n3FormDocs">Form</a> </p>
</div>
</template>

</section></template>

<script>
export default {
  data () {
    return {
      value: '',
      value2: ''
    }
  },
  mounted () {
    this.value = 100
  }
}
</script>


// WEBPACK FOOTER //
// n3InputDocs.md?40c10fe8